export class ResendOtpRequestBody {
    loginId: string;
}
